import Api from './api';

export const getByUserId = async (userId) => {
  let data = null;
  await Api.get(`/userdistributionconfig/user/${userId}`)
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = err;
    });
  return data;
};

export const createOrUpdate = async (config) => {
  let data = null;
  await Api.post('/userdistributionconfig', config)
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = err;
    });
  return data;
};
